module.exports = __webpack_public_path__ + "img/image_1.2528ab31.png";